import React, { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import SLUGS from '../resources/routesConstants';
import LoadingComponent from 'components/loading/loader';

// Lazy-load all public pages for code splitting
const Start = lazy(() => import('../components/Start/index'));
const Login = lazy(() => import('components/Login'));
const Signup = lazy(() => import('components/Signup/signup'));
const SetUpUser = lazy(() => import('components/Signup/setUpUser'));
const BookDemo = lazy(() => import('components/Signup/BookDemo'));
const ForgotPassword = lazy(() => import('components/ForgotPassword'));
const Terms = lazy(() => import('components/TermsPolicies/Terms'));
const PrivatePolicy = lazy(() => import('components/TermsPolicies/Policies'));
const Registration = lazy(() => import('container/Registration/Registration'));
const UpdatePassword = lazy(() => import('container/UpdatePassword/updatePassword'));

/** Redirect to an external URL (outside the SPA) */
function ExternalRedirect({ to }) {
  React.useEffect(() => { window.location.href = to; }, [to]);
  return <LoadingComponent />;
}

function PublicRoutes() {
  return (
    <Suspense fallback={<LoadingComponent />}>
      <Routes>
        {/* Routes */}
        <Route path={SLUGS.start} element={<Start />} />
        <Route path={SLUGS.login} element={<Login />} />
        {/* Signup redirects to collabkare.id registration portal */}
        <Route path={SLUGS.signup} element={<ExternalRedirect to="https://collabkare.id/register" />} />
        <Route path={SLUGS.setUpUser} element={<SetUpUser />} />
        <Route path={SLUGS.forgotPassword} element={<ForgotPassword />} />
        <Route path={SLUGS.terms} element={<Terms />} />
        <Route path={SLUGS.policies} element={<PrivatePolicy />} />
        <Route path={SLUGS.bookDemo} element={<BookDemo />} />
        <Route path={SLUGS.registration} element={<Registration />} />
        <Route path={SLUGS.updatePassword} element={<UpdatePassword />} />

        {/* Root shows the landing page */}
        <Route path="/" element={<Start />} />

        {/* Catch-all → landing page */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}

export default PublicRoutes;
